// Property images from mayer.co.tz + background images
export const IMAGES = {
  // Hero & background images
  HERO_MAIN: "/images/prop7.jpg",
  HERO_BG_2: "/images/prop9.jpg",
  INVEST_BG: "/images/prop18.jpg",
  VILLA_PROPERTY_1: "/images/prop2.jpg",

  // Individual listing cover images (prop1–prop51)
  PROP1: "/images/prop1.jpg",
  PROP2: "/images/prop2.jpg",
  PROP3: "/images/prop3.png",
  PROP4: "/images/prop4.jpg",
  PROP5: "/images/prop5.png",
  PROP6: "/images/prop6.jpg",
  PROP7: "/images/prop7.jpg",
  PROP8: "/images/prop8.jpg",
  PROP9: "/images/prop9.jpg",
  PROP10: "/images/prop10.jpg",
  PROP11: "/images/prop11.jpg",
  PROP12: "/images/prop12.jpg",
  PROP13: "/images/prop13.jpg",
  PROP14: "/images/prop14.png",
  PROP15: "/images/prop15.png",
  PROP16: "/images/prop16.png",
  PROP17: "/images/prop17.jpg",
  PROP18: "/images/prop18.jpg",
  PROP19: "/images/prop19.jpg",
  PROP20: "/images/prop20.jpg",
  PROP21: "/images/prop21.jpg",
  PROP22: "/images/prop22.jpg",
  PROP23: "/images/prop23.jpg",
  PROP24: "/images/prop24.png",
  PROP25: "/images/prop25.jpg",
  PROP26: "/images/prop26.jpg",
  PROP27: "/images/prop27.jpg",
  PROP28: "/images/prop28.jpg",
  PROP29: "/images/prop29.png",
  PROP30: "/images/prop30.jpg",
  PROP31: "/images/prop31.png",
  PROP32: "/images/prop32.png",
  PROP33: "/images/prop33.png",
  PROP34: "/images/prop34.jpg",
  PROP35: "/images/prop35.png",
  PROP36: "/images/prop36.png",
  PROP37: "/images/prop37.jpg",
  PROP38: "/images/prop38.jpg",
  PROP39: "/images/prop39.jpg",
  PROP40: "/images/prop40.jpg",
  PROP41: "/images/prop41.jpg",
  PROP42: "/images/prop42.jpg",
  PROP43: "/images/prop43.jpg",
  PROP44: "/images/prop44.jpg",
  PROP45: "/images/prop45.png",
  PROP46: "/images/prop46.jpg",
  PROP47: "/images/prop47.jpg",
  PROP48: "/images/prop48.png",
  PROP49: "/images/prop49.jpg",
  PROP50: "/images/prop50.jpg",
  PROP51: "/images/prop51.jpg",

  // Shared gallery pool (real mayer.co.tz property photos used as additional gallery images)
  GAL_A: "/images/gallery_a.jpg",
  GAL_B: "/images/gallery_b.jpg",
  GAL_C: "/images/gallery_c.jpg",
  GAL_D: "/images/gallery_d.jpg",
  GAL_E: "/images/gallery_e.jpg",
  GAL_F: "/images/gallery_f.jpg",
  GAL_G: "/images/gallery_g.jpg",
  GAL_H: "/images/gallery_h.jpg",
  GAL_I: "/images/gallery_i.jpg",
  GAL_J: "/images/gallery_j.jpg",
  GAL_P5B: "/images/gallery_p5b.jpg",
  GAL_P5C: "/images/gallery_p5c.jpg",
} as const;

export type ImageKey = keyof typeof IMAGES;
